import React, { useContext, useEffect, useState } from "react";
import { Content } from "../components/Content";
import { getAssetTypes } from "../services/bags";
import { contextApi } from "../context/contextApi";
import { Loading } from "../components/common/Loading";

export const Dashboard = () => {
  const context = useContext(contextApi);
  const [assetTypes, setAssetTypes] = useState([]);

  const fetchAssetTypes = async () => {
    try {
      const res = await getAssetTypes();
      setAssetTypes(res?.data?.data ?? []);
      context.setLoad(false);
    } catch (error) {
      context.setLoad(false);
    }
  };

  useEffect(() => {
    context.setLoad(true);
    fetchAssetTypes();
  }, []);

  return (
    <div className="flex flex-row h-full basis-full bg-white dark:bg-[#0D1117]">
      <Loading show={context.load} />
      <Content assetTypes={assetTypes} pageName="پیشخوان" />
    </div>
  );
};
